module.exports = __webpack_public_path__ + "img/sustainability.928d0d5.jpg";